module.exports = __webpack_public_path__ + "img/168.b2eb3af3.jpg";